import React, {useEffect, useState} from 'react';
// import { Link } from 'react-router-dom';
import Carousel from '../../components/Carousel';
// import useBreadCrumb from '../../hooks/breadCrumb';
import services from '../../services';
import {generateLinkWithLang} from '../../utils/linkGenerator';
import {useTranslation} from 'react-i18next';
// Arabic Banners
import crisesManagementCarousalBannerAr
    from '../../images/banners/carousal-banners-ar/crises_management_palestine_carousal_banner_ar.png'
import jummahGivingCarousalBannerAr from '../../images/banners/carousal-banners-ar/jummah_giving_carousal_banner_ar.png'
import buildMasjidCarousalBannerAr from '../../images/banners/carousal-banners-ar/build_masjid_carousal_banner_ar.png'
import gazaBabiesCarousalBannerAr from '../../images/banners/carousal-banners-ar/gaza_babies_carousal_banner_ar.png'
import careForOrphanCarousalBannerAr
    from '../../images/banners/carousal-banners-ar/care_for_orphan_carousal_banner_ar.png'
import palestineEmergencyCarousalBannerAr
    from '../../images/banners/carousal-banners-ar/palestine_emergency_carousal_banner_ar.png'
import waterWellCarousalBannerAr from '../../images/banners/carousal-banners-ar/water_well_carousal_banner_ar.png'
import zakatCarousalBannerAr from '../../images/banners/carousal-banners-ar/zakat_carousal_banner_ar.png'
import qurbaniBannerAr from '../../images/qurban/qurban_banner_ar.png'

const detectLanguageFromURL = () => {
    const pathname = window.location.pathname;
    const segments = pathname.split('/').filter(Boolean);

    // Supported languages
    const supportedLanguages = ['ar', 'fr', 'es'];

    // Check if first segment is a supported language code
    if (segments.length > 0 && supportedLanguages.includes(segments[0])) {
        return segments[0];
    }

    return 'en'; // Default to English
};

export default function CarouselSection() {
    /* ----------------------------- Start variables ---------------------------- */
    // const { inserMenuRoute } = useBreadCrumb();
    const {i18n} = useTranslation();

    // First check URL, then fallback to i18n.language
    const lang = i18n.language;
    const [currentLang, setCurrentLang] = useState(() => detectLanguageFromURL());
    const [banners, setBanners] = useState([]);
    // const carouselItems = [
    //   { url: '/food-and-water-aid', img: 'carousel-homepage-food-and-water-aid.jpg', name: 'food-and-water-aid', isSubCategory: false },
    //   { url: '/donate-now/make-a-donation', img: 'carousel-homepage-general-donations.jpg', name: 'make-a-donation', parentName: 'donate-now', isSubCategory: true },
    //   { url: '/zakat-calculator', img: 'carousel-homepage-zakat-calculator.jpg', name: 'qurban', isSubCategory: false },
    //   { url: '/sadaqah-jariyah/build-a-masjid', img: 'carousel-homepage-build-a-masjid-.jpg', name: 'build-a-masjid', parentName: 'sadaqah-jariyah', isSubCategory: true },
    //   { url: '/sadaqah-jariyah/build-a-water-well', img: 'carousel-homepage-build-a-water-well-.jpg', name: 'build-a-water-well', parentName: 'sadaqah-jariyah', isSubCategory: true },
    //   { url: '/orphans', img: 'carousel-homepage-orphans-.jpg', name: 'orphans', isSubCategory: false },
    //   { url: '/sadaqah-jariyah', img: 'carousel-homepage-sadaqah-jariyah-.jpg', name: 'sadaqah-jariyah', isSubCategory: false },
    //   { url: '/donate-now', img: 'carousel-homepage-recurring-donations-.jpg', name: 'donate-now', isSubCategory: false },
    //   { url: '/app', img: 'carousel-homepage-mobile-app-.jpg', name: 'app', isSubCategory: false },
    //   // { url: '/qurban-2023', img: 'carousel-homepage-qurban-impact.jpg', name: 'qurban', isSubCategory: false },
    //   // { url: '/crisis-and-emergencies/palestine', img: 'carousel-homepage--palestine.jpg', name: 'palestine',parentName: 'crisis-and-emergencies', isSubCategory: true },
    //   // { url: '/crisis-and-emergencies/palestine', img: 'carousel-homepage-emergency-support-for-palestine.jpg', name: 'palestine',parentName: 'crisis-and-emergencies', isSubCategory: true },
    //   // { url: '/zakat', img: 'carousel-homepage-zakat-impact.jpg', name: 'qurban', isSubCategory: false },
    //   // { url: '/qurban', img: 'carousel-homepage-qurban.jpg', name: 'qurban', isSubCategory: false },
    //   // { url: 'https://blog.matwproject.org/', img: 'carousel-homepage-blog.jpg', name: 'blog', isSubCategory: false },
    // ];
    const isUKDomain = window.location.hostname === 'matwproject.org.uk' || window.location.hostname === 'localhost' || window.location.hostname === 'uat.matwproject.org';
    // const isAUDomain = window.location.hostname === 'matwproject.org' || window.location.hostname === 'localhost' || window.location.hostname === 'uat.matwproject.org';
    /* -------------------------------------------------------------------------- */

    /* ------------------------------ Start methods ----------------------------- */
    const handleClick = () => {
        // console.log('clicked');
    };
    const getBanners = async () => {
        try {
            const response = await services.getBanners();
            let temp = response.data.sort((a, b) => {
                return a.order - b.order;
            });
            // console.log('response get getBanners', response);
            // console.log('response get getBanners 2', temp);
            let temp2 = [];
            // temp = temp.filter(item => item.is_page_banner !== 1)
            // temp.map((item, index) => {
            //   if (item.status !== 0 && item.section === 'slider') {
            //     temp2.push(item);
            //   }
            //   return item;
            // });

            temp.map((item) => {
                // If isUKDomain is true, remove banners with "zakat" in the link
                if (item.status !== 0 && item.section === 'slider') {
                    if (isUKDomain && item.link.includes("zakat")) {
                        return; // Skip this item (exclude it from temp2)
                    }
                    temp2.push(item);
                }
                return item;
            });

            // if (isAUDomain) {
            //   const qurbanBanner = {
            //     name: 'Qurban',
            //     link: generateLinkWithLang('/qurban', lang === 'ar' ? '' : lang),
            //     image: qurbanAU,
            //   };
            //   temp2.splice(2, 0, qurbanBanner); // Insert at 3rd position
            // } else {
            //   const qurbaniBanner = {
            //     name: 'Qurbani',
            //     link: generateLinkWithLang('/qurbani', lang === 'ar' ? '' : lang),
            //     image: qurbaniPhoto,
            //   };
            //   temp2.splice(2, 0, qurbaniBanner); // Insert at 3rd position
            // }
            if (currentLang === 'ar') {
                // https://matwproject.org/qurban
                const qurbanIndex = temp2.findIndex(item => item.link.includes('/qurban'));
                if (qurbanIndex !== -1) {
                    temp2[qurbanIndex].image = qurbaniBannerAr;
                }

                //https://matwproject.org/crisis-and-emergencies/palestine
                const crisesManagementIndex = temp2.findIndex(item => item.link.includes('/crisis-and-emergencies/palestine'));
                if (crisesManagementIndex !== -1) {
                    temp2[crisesManagementIndex].image = crisesManagementCarousalBannerAr;
                }

                //https://matwproject.org/zakat
                const zakatIndex = temp2.findIndex(item => item.link.includes('/zakat'));
                if (zakatIndex !== -1) {
                    temp2[zakatIndex].image = zakatCarousalBannerAr;
                }

                //https://matwproject.org/appeals/gaza-babies
                const gazaBabiesIndex = temp2.findIndex(item => item.link.includes('/appeals/gaza-babies'));
                if (gazaBabiesIndex !== -1) {
                    temp2[gazaBabiesIndex].image = gazaBabiesCarousalBannerAr;
                }

                //https://matwproject.org/appeals/palestine-emergency
                const palestineEmergencyIndex = temp2.findIndex(item => item.link.includes('/appeals/palestine-emergency'));
                if (palestineEmergencyIndex !== -1) {
                    temp2[palestineEmergencyIndex].image = palestineEmergencyCarousalBannerAr;
                }

                //https://matwproject.org/jummah-giving
                const jummahGivingIndex = temp2.findIndex(item => item.link.includes('jummah-giving'));
                if (jummahGivingIndex !== -1) {
                    temp2[jummahGivingIndex].image = jummahGivingCarousalBannerAr;
                }

                //https://matwproject.org/orphans
                const orphanIndex = temp2.findIndex(item => item.link.includes('/orphans'));
                if (orphanIndex !== -1) {
                    temp2[orphanIndex].image = careForOrphanCarousalBannerAr;
                }

                //https://matwproject.org/sadaqah-jariyah/build-a-masjid
                const buildMasjidIndex = temp2.findIndex(item => item.link.includes('/sadaqah-jariyah/build-a-masjid'));
                if (buildMasjidIndex !== -1) {
                    temp2[buildMasjidIndex].image = buildMasjidCarousalBannerAr;
                }

                //https://matwproject.org/sadaqah-jariyah/build-a-water-well
                const buildWaterWellIndex = temp2.findIndex(item => item.link.includes('sadaqah-jariyah/build-a-water-well'));
                if (buildWaterWellIndex !== -1) {
                    temp2[buildWaterWellIndex].image = waterWellCarousalBannerAr;
                }
            }


            // let zakatUKDomainImage = {
            //   "id": 16,
            //   "name": "Zakat-Rewards-Banner.jpg",
            //   "alt": null,
            //   "link": "/zakat",
            //   "image": ZakatImg,
            //   "mobile_image": null,
            //   "disk": "s3",
            //   "domain": null,
            //   "order": 50,
            //   "status": 0,
            //   "section": "slider",
            //   "is_page_banner": 0,
            //   "created_at": "2023-07-19 19:08:46",
            //   "updated_at": "2024-06-14 23:29:12",
            //   "deleted_at": null
            // }
            // isUKDomain && temp2.unshift(zakatUKDomainImage)
            // console.log('temp2temp2',temp2)
            setBanners(temp2);
        } catch (error) {
            console.error('error========', error);
        }
    };
    /* -------------------------------------------------------------------------- */

    /* ------------------------------- Start hooks ------------------------------ */
    useEffect(() => {
        getBanners();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    /* -------------------------------------------------------------------------- */
    return (<div
        className="w-full md:py-2 min-h-[200px]- sm:min-h-[330px]- md:min-h-[393px] lg:min-h-[550px] xl:min-h-[674px] 2xl:min-h-[800px]">
        {banners.length ? (<Carousel
            // {<Carousel
            withArrow={false}
            autoSwitch={true}
            // data={carouselItems}
            data={banners}
            renderItem={({item, index, currentSlide}) => {
                const isActive = currentSlide === index;
                const overrideLink = isUKDomain && item.link === "/30-steps-to-jannah" ? 'https://matwproject.org/30-steps-to-jannah' : generateLinkWithLang(item.link, lang);

                return (<div onClick={handleClick} className="md:p-2" key={`carousel${index}`}>
                    <div
                        className={`w-full h-auto transition-all transform md:rounded-xl overflow-hidden lg:min-h-[490px] xl:min-h-[614px] 2xl:min-h-[740px] ${isActive ? 'scale-100' : 'opacity-75 scale-90'}`}
                    >
                        {/* <a href={item.url} onClick={() => {
                  item.isSubCategory ? inserMenuRoute(true, item.name, `/${item.parentName}/${item.name}`, { name: item.parentName, id: `/${item.parentName}` })
                    : inserMenuRoute(false, item.name, `/${item.name}`)
                }}>
                  <img
                    className={`w-full h-full object-center cursor-pointer object-cover md:rounded-xl`}
                    alt={item}
                    src={`/images/carouselImages/${item.img}`}
                  />
                </a> */}
                        <a
                            href={overrideLink}
                            target={isUKDomain && index === 2 ? '_blank' : '_self'}
                            rel={isUKDomain && index === 2 ? 'noopener noreferrer' : ''}
                        >
                            <img
                                className={`w-full h-full object-center cursor-pointer object-cover md:rounded-xl`}
                                alt={item.name} src={`${item.image}`}/>
                        </a>
                    </div>
                </div>);
            }}
            keyExtractor={item => item.image}
            // keyExtractor={item => item.url}
        />) : (<></>)}
    </div>);
}
